import { IApplicationState } from '../../types/redux';

export function getMapApiVersion(state: IApplicationState) {
  return state.common.mapApiVersion || undefined;
}
